import { Component, Input, ViewChild } from '@angular/core';
import { MenuItemModel } from '../../utilidades.modelos.index';
import { MatMenu } from '@angular/material/menu';

@Component({
	selector: "app-submenu",
	templateUrl: "./submenu.component.html"
})
export class SubmenuComponent {

	@Input("Items") Items: MenuItemModel[] = [];
	@ViewChild('submenu', { static: false }) public Submenu: MatMenu;

	constructor() { }
}